var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./carehome-patient-create.scp.html"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-01356aef\"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./carehome-patient-create.scp.html"),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "C:\\Products\\VCare\\Sourcecode\\branches\\UAT\\VCarePortal\\PharmacyPortal\\ClientApp\\components\\carehome-patients\\create\\carehome-patient-create.scp.html"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] carehome-patient-create.scp.html: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-01356aef", Component.options)
  } else {
    hotAPI.reload("data-v-01356aef", Component.options)
  }
})()}

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./ClientApp/components/carehome-patients/create/carehome-patient-create.scp.html
// module id = 43
// module chunks = 0